import { render } from "./DataInventoryAnalysis.vue?vue&type=template&id=735474f0"
import script from "./DataInventoryAnalysis.vue?vue&type=script&lang=js"
export * from "./DataInventoryAnalysis.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__